import * as moment from 'moment';
import * as _ from 'lodash';
import * as $ from 'jquery';

import { Component, OnInit, ViewChild, Input } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
import { } from '@types/googlemaps';
import { LocationServices } from '../../../services/LocationServices';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';


@Component({
    selector: 'student-location-details',
    template: require('./StudentLocationComponent.html'),
    styles: [require('./StudentLocationComponent.sass')]
})

export class StudentLocationComponent implements OnInit {
    @ViewChild('gmap') gmapElement: any;
    @Input() set content(value: any){
        this.infoBus = value;
        if(this.locationSubscription instanceof Subscription) this.locationSubscription.unsubscribe();
        if(this.infoBus) this.initMap();
    };

    infoBus: any;

    map: google.maps.Map;
    place: any;
    locationSubscription: Subscription;
    marker: any = [];

    constructor(
        private locationService: LocationServices
    ) {

    }

    ngOnDestroy(){
        this.locationSubscription.unsubscribe();
    }

    ngOnInit() {
     
    }

    initMap(){
        const mapProp = {
            center: new google.maps.LatLng(10.799246, 106.6595112),
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
        
        this.locationSubscription = this.locationService.getMessages('busLocationClient').subscribe(
            (data: any) => {
                this.marker.setMap && this.marker.setMap(null);
                const location = JSON.parse(data);
                if (this.infoBus.bus.code == location.bus_code) {
                    const markerPlace = new google.maps.LatLng(location.lat, location.long);
                    this.setMarket(markerPlace, location.bus_code);
                    this.map.setCenter(markerPlace);
                }
                else {
                    this.setMarket(null, '');
                }
            },
            (err: any) => {
                console.log(err);
            }
        )
    }

    setMarket(markerPlace: any, nameOfBus: any) {
        this.marker = new google.maps.Marker({
            position: markerPlace,
            title: nameOfBus
        });
        this.marker.setMap(this.map);
    }
}


// WEBPACK FOOTER //
// ./src/bus/parent/bus-attendance/student-location/StudentLocationComponent.ts